import React from "react";

const AuthContext = React.createContext<any>(null);

export default AuthContext;